import { render, staticRenderFns } from "./liberacion-sancion-observacion-resumen.vue?vue&type=template&id=bdceded2&"
import script from "./liberacion-sancion-observacion-resumen.vue?vue&type=script&lang=ts&"
export * from "./liberacion-sancion-observacion-resumen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports